import { Container } from "@mui/material";
import { useEffect } from "react";
import { folderMappingsStorage } from "utils/localStorage";
import Layout from "../components/Layout";
import Login from "../components/Login";

export default function LoginPage() {
  useEffect(() => {
    folderMappingsStorage.clearFolderMappings();
  }, []);
  return (
    <Layout title="Login" content="Login Page" >
      <Container component="main" maxWidth="xs">
        <Login />
      </Container>
    </Layout>
  );
}
